import React from 'react'
import { Theme, Typography } from '@material-ui/core'
import { Container } from '../../../../components'
import { ResidentTermDirectoryRow } from '../../../../models/DocumentAudit/types'

interface Props {
    row: ResidentTermDirectoryRow | null
    theme: Theme
}

export const ModalHeader = ({ row, theme }: Props) => {
    if (!row) return null

    return (
        <Container
            style={{
                marginBottom: theme.spacing(2),
                alignItems: 'center',
            }}
        >
            <Typography
                variant="h6"
                style={{
                    marginRight: theme.spacing(2),
                    fontWeight: 700,
                }}
            >
                {row.customer.name}
            </Typography>
            <Typography>
                {new Date(row.lease_start).toLocaleDateString()} -{' '}
                {new Date(row.lease_end).toLocaleDateString()}
            </Typography>
        </Container>
    )
}
